{
  "settings": "Settings",
  "yourDigitalAssistant": "Your Digital Assistant",
  "getStarted": "Get Started",
  "login": "Login",
  "loggingIn": "Logging in ...",
  "darkMode": "Dark mode",
  "clearHistory": "Clear history",
  "historyCleared": "History cleared",
  "changeLanguage": "Language",
  "termsAndConditions": "Terms of Use",
  "messagePlaceholder": "Type your message here ...",
  "messagePlaceholderDisabled": "Typing disabled ...",
  "feedbackTitle": "Rate your experience",
  "feedbackPlaceholder": "Tell us about it (optional)",
  "feedbackSend": "Send",
  "feedbackClose": "Close",
  "sessionExpired": "Your session has expired due to inactivity.",
  "startNewSession": "Start a new session",
  "apiError": "Oops! Something went wrong. We're working on getting this fixed as soon as we can.",
  "apiErrorOffline": "You are not connected to the internet.",
  "tryAgain": "Try again",
  "startOver": "Start over",
  "chatEnded": "Chat has ended.",
  "chatEndedThankYou": "Thank you for chatting with us!",
  "closeChat": "Close",
  "startNewChat": "Chat again",
  "humanTakeoverStarted": "You are now being transferred to customer service ...",
  "humanTakeoverQueued": "Waiting to get connected to an agent",
  "humanTakeoverAnAgent": "An agent",
  "humanTakeoverAgentEntered": "entered the conversation",
  "humanTakeoverAgentLogout": "left the conversation",
  "humanTakeoverTransfer": "You are being transferred to a new agent",
  "humanTakeoverEnded": "You are now chatting with your digital assistant",
  "version": "Version",
  "formIntroText": "Please fill the following form to start chatting with us.",
  "formFirstName": "First name",
  "formLastName": "Last name",
  "formName": "Name",
  "formEmail": "E-mail",
  "formWrongEmail": "Please provide a valid e-mail address.",
  "formPhone": "Phone",
  "formShipmentId": "Shipment ID",
  "formQuestion": "Your question",
  "formAccountNumber": "Account number (for Business Customers)",
  "formAddress": "Address",
  "formPostcode": "Postcode",
  "formCity": "City",
  "formCountry": "Country",
  "formSubmitButton": "Start chat",
  "formEmptyFieldError": "Not allowed to be empty.",
  "formPhoneNumberValidationError": "Not a valid phone number.",
  "formInputIsBiggerThan50": "Must be at most 50 characters.",
  "formInputIsBiggerThan100": "Must be at most 100 characters.",
  "formInputIsBiggerThan2000": "Must be at most 2000 characters.",
  "widgetEventOnline": "DA message: User is back online.",
  "widgetEventHidden": "DA message: Widget is hidden.",
  "widgetEventVisible": "DA message: Widget is visible.",
  "widgetEventVisibleMinimized": "DA message: Widget is visible, but minimized.",
  "widgetEventMinimized": "DA message: Widget is minimized.",
  "widgetEventMaximized": "DA message: Widget is maximized.",
  "widgetEventSessionExpired": "DA message: Widget session expired.",
  "widgetEventUserTyping": "DA message: User is typing.",
  "widgetEventHangupHuman": "DA message: User ending Human takeover session.",
  "fileTooLarge": "You Are Attempting To Attach Too Big Files.",
  "tooManyDiles": "You Are Attempting To Attach Too Many Files.",
  "fileInvalidType": "You Are Attempting To Attach Invalid File Types.",
  "attachmentsDropHere": "Drop here to upload or",
  "attachmentsBrowse": "Browse Files",
  "attachmentsExtenstionQuantity": "pdf or images (up to 10 files)",
  "attachmentsSize": "up to 30 MB",
  "attachmentsFailedUploading": "Uploading Failed",
  "attachmentsUploading": "Uploading...",
  "minimizeExpandText": "Live chat with us now!",
  "popupWidgetNotificationMessage": "You received a new message!",
  "tabWidgetNotificationMessage": "New Message!",
  "datepickerSendButton": "Send"
}
